import React from 'react';
import { Check, AlertCircle } from 'lucide-react';

export const StatusMessage = ({ status, theme }) => {
  if (!status) return null;
  
  return (
    <>
      {status === 'success' && (
        <div className={`mt-4 ${theme.successMessage} flex items-center space-x-2`}>
          <Check size={20} />
          <span>Form submitted successfully!</span>
        </div>
      )}
      
      {status === 'error' && (
        <div className={`mt-4 ${theme.errorMessage} flex items-center space-x-2`}>
          <AlertCircle size={20} />
          <span>An error occurred. Please try again.</span>
        </div>
      )}
    </>
  );
};